module.exports = __webpack_public_path__ + "school/img/enTrainDetail2.17a5a318.jpg";